import {
  SearchJoinApplicationsResponse,
  CursorSearch,
} from './src/online-programs-participants-v3-join-application-join-applications.universal';

export * from './src/online-programs-participants-v3-join-application-join-applications.universal.js';

/** @hidden */
export type JoinApplicationSearch = {};

/**
 * Searches join applications with text-based filtering across member information (email, name, nickname) and supports aggregation.
 *
 * Returns matching applications with cursor-based pagination.
 * @param search - WQL expression.
 * @public
 * @documentationMaturity preview
 * @requiredField search
 * @permissionId online_programs:participants:v3:join_application:search_join_applications
 * @applicableIdentity APP
 * @fqn wix.onlineprograms.joinapplications.v3.JoinApplicationsService.SearchJoinApplications
 */
export declare function searchJoinApplications(
  search: CursorSearch
): Promise<SearchJoinApplicationsResponse>;
